import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { CellDropdownSWReactTableOnRowHover } from "../../pages/components/CellSiteDropdown";

export const TableWrapper = styled(Box)`
    width: 100%;
    max-width: 1368px;
    height: auto;
    border-radius: 6px;
    overflow: hidden;

    display: block;
    ${CellDropdownSWReactTableOnRowHover}
`;
TableWrapper.displayName = "TableWrapper";

export const DropDownContainer = styled.div`
    background-color: ${colorsPalettes.carbon["0"]};
    padding: 12px;

    [data-automation-icon-name="arrow"] svg {
        width: 10px;
        height: 5px;
    }
`;

export const SearchContainer = styled(FlexRow)<{ withBorderTop: boolean }>`
    align-items: center;
    padding: 8px 16px 8px 0;
    height: 40px;
    border-top: ${({ withBorderTop }) => withBorderTop && `1px solid ${colorsPalettes.carbon[100]}`};
    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;

export const StyledTableTitle = styled(Text)`
    height: 63px;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 20px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    display: block;
`;
